/* ═══════════════════════════════════════════════════════════════════════════
   BEST LOGO MATS — HD Printed Entryway Mat Design Station (2026-10-06)
   Functional sibling of BoatMat's hd-yachtmat-station.js, rebuilt for BLM:
   no base-color step (the mat is printed), Best Logo Mats visual identity
   (styling lives in the section's {% style %}, not here).

   STEP 1 size → STEP 2 upload → STEP 3 live preview + Add to Cart.
   PRICE AUTHORITY: the Shopify variant id priced server-side. window.BLM_STATION
   carries the real variants (id, label, price in cents, custom flag) injected
   from Liquid — nothing is hardcoded here.

   Add to Cart keeps the native Shopify {% form 'product' %} (reliable multipart
   file upload → the logo attaches to the exact line item). Before submit we
   upload the on-screen preview PNG to BMOS and inject the Design Station
   line-item properties (_design_station='blm-entryway', _preview_url, …) so the
   same proof pipeline that serves BoatMat generates a Best Logo Mats proof,
   emailed to info@bestlogomats.com (routed server-side by _design_station).
   Custom Size never adds to cart — it opens the Best Logo Mats quote modal.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  if (window.__blmStation) return; window.__blmStation = 1;
  var DP_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/design-proof/preview';
  var CSQ_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/custom-size-quote';
  // Defined up here (not lower) so the quote-only early-return path still has them.
  var ARTWORK_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/quote-artwork';
  var SUBMIT_LABEL = 'REQUEST MY CUSTOM QUOTE';
  // ── Per-product configuration (ONE engine, product-specific config) ──
  // window.BLM_CONFIG, injected per product, drives which steps/features show.
  // Backward-compatible: absent config = the original HD Entryway behaviour.
  var CONFIG = window.BLM_CONFIG || {};
  var STATION = CONFIG.station || 'blm-entryway';
  var COLOR_ENABLED = CONFIG.colorEnabled !== undefined ? !!CONFIG.colorEnabled : !!document.getElementById('blmColorGrid');
  var CFG = window.BLM_STATION || { sizes: [] };
  var IMG_RE = /\.(png|jpe?g|gif|webp|svg)$/i;

  // ── 150-color HD palette (reused verbatim from BoatMat: HD_COLORS + HD_SPRITE
  //    from sportfish-hd-colors.js, swatches from hd-sprite.webp). Same data,
  //    same names (PMS #), same values, same sprite — BLM-styled UI only. ──
  var HD_COLORS = window.HD_COLORS || [];
  var HD_SPRITE = window.HD_SPRITE || { cols: 15, rows: 10, cell: 44 };
  var SPRITE_URL = window.HDYM_SPRITE_URL || '';
  var DEFAULT_CELL = CONFIG.defaultCell || 'O8'; // charcoal-gray — a professional default entrance-mat base
  var sprite = null, spriteReady = false;
  if (SPRITE_URL) { sprite = new Image(); sprite.onload = function () { spriteReady = true; render(); }; sprite.src = SPRITE_URL; }
  function colorByCell(cell) { for (var i = 0; i < HD_COLORS.length; i++) if (HD_COLORS[i].c === cell) return HD_COLORS[i]; return null; }

  // ── Per-color carpet tiles for the MAT SURFACE (BoatMat's proven method) ──
  // The small sprite cell is only good for the picker swatch; the live mat is
  // painted from the real hd-tile-<CODE>.jpg carpet texture via createPattern
  // ('repeat'), which preserves the true PMS color + crisp texture (no upscale
  // muting). Served cross-origin-safe through the BMOS proxy so the canvas stays
  // untainted and the preview PNG can still upload for the PDF proof.
  var TILE_BASE = window.BLM_TILE_BASE || 'https://admin.boatmat.com/public/web-intake/hd-tile/';
  var tileCache = {};
  function tileImg(code, cb) {
    if (tileCache[code] !== undefined) { cb(tileCache[code]); return; }
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () { tileCache[code] = im; cb(im); };
    im.onerror = function () { tileCache[code] = null; cb(null); };
    im.src = TILE_BASE + code + '.jpg';
  }
  // NOTE: adds a rounded-rect SUBPATH to the current path (no beginPath) so an
  // evenodd band clip (outer rect + inner rect) works — callers beginPath first.
  function roundRect(c, x, y, w, h, r) { r = Math.min(r, w / 2, h / 2); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }

  function el(id) { return document.getElementById(id); }
  function qs(s, r) { return (r || document).querySelector(s); }
  function designId() { return 'blm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }

  // ── State ──────────────────────────────────────────────────────────────────
  var S = {
    size: null,            // selected size object from CFG.sizes
    color: null,           // selected color object {c,n,h,f} from HD_COLORS
    orientation: 'landscape', // 'landscape' (wide) | 'portrait' (runner, tall)
    file: null,            // the File the customer chose
    logoName: '',
    logoImg: null,         // HTMLImageElement when previewable, else null
    art: { scale: 0.5, dx: 0, dy: 0 },
  };

  // Wire the custom-size / quote modal. Runs for BOTH priced products (which also
  // have a form) and quote-only products (no form) — the modal is the whole UI there.
  function wireCsq() {
    bind('blmCustomOpen', openCsq);
    bind('blmCsqSend', sendCsq);
    var csqF = el('blmCsqFile'), csqFN = el('blmCsqFileName');
    if (csqF && csqFN) csqF.addEventListener('change', function () { csqFN.textContent = (csqF.files && csqF.files[0]) ? ('✓ ' + csqF.files[0].name) : ''; });
    var x = el('blmCsqClose'); if (x) x.addEventListener('click', closeCsq);
    var x2 = el('blmCsqCloseDone'); if (x2) x2.addEventListener('click', closeCsq);
    var ovl = el('blmCsq'); if (ovl) ovl.addEventListener('click', function (e) { if (e.target === ovl) closeCsq(); });
  }

  var form = qs('.blm-entry__form');
  if (!form) { wireCsq(); return; } // quote-only product (no priced variants): wire the quote modal, done
  var variantInput = qs('[data-blm-variant-input]', form);
  var fileInput = qs('[data-blm-fileinput]', form);
  var cv = el('blmPreviewCanvas');
  var ctx = cv ? cv.getContext('2d') : null;

  // ── Size selection ───────────────────────────────────────────────────────
  function sizeFor(id) { for (var i = 0; i < CFG.sizes.length; i++) if (String(CFG.sizes[i].id) === String(id)) return CFG.sizes[i]; return null; }
  // Oriented display dimensions. Landscape = longer side horizontal; Portrait /
  // Runner = longer side vertical. The ordered size (the Shopify variant) is
  // unchanged — this only flips how the mat is shown.
  function dims(label) {
    var m = String(label || '').match(/(\d+(?:\.\d+)?)[^\d]+(\d+(?:\.\d+)?)/);
    var a = m ? +m[1] : 3, b = m ? +m[2] : 2;
    var lo = Math.min(a, b), hi = Math.max(a, b);
    return S.orientation === 'portrait'
      ? { wFt: lo, hFt: hi, lo: lo, hi: hi }
      : { wFt: hi, hFt: lo, lo: lo, hi: hi };
  }
  function orientationLabel() {
    var d = dims(S.size ? S.size.label : '');
    var fmt = function (n) { return (n % 1 === 0 ? n : n.toFixed(1)) + "'"; };
    return (S.orientation === 'portrait' ? 'Portrait / Runner' : 'Landscape') + ' (' + fmt(d.wFt) + ' wide × ' + fmt(d.hFt) + ' deep)';
  }

  function selectSize(sizeObj, pill) {
    S.size = sizeObj;
    var pills = form.querySelectorAll('.blm-entry__size-pill');
    for (var i = 0; i < pills.length; i++) pills[i].classList.remove('is-selected');
    if (pill) pill.classList.add('is-selected');
    var isCustom = !!sizeObj && sizeObj.custom;
    // Toggle the standard order block vs the custom-size quote block.
    var orderBlock = el('blmOrderBlock'), customBlock = el('blmCustomBlock');
    if (orderBlock) orderBlock.hidden = isCustom;
    if (customBlock) customBlock.hidden = !isCustom;
    if (!isCustom && sizeObj) {
      if (variantInput) variantInput.value = sizeObj.id;
      var priceEl = qs('[data-blm-price]');
      if (priceEl && priceEl.childNodes[0]) priceEl.childNodes[0].nodeValue = sizeObj.priceStr;
      var sumSize = el('blmSumSize'); if (sumSize) sumSize.textContent = sizeObj.label;
      var sumPrice = el('blmSumPrice'); if (sumPrice) sumPrice.textContent = sizeObj.priceStr;
    }
    render();
  }

  // ── Step 2: 150-color palette (BoatMat HD_COLORS + hd-sprite.webp) ──────────
  function buildColors() {
    var host = el('blmColorGrid');
    if (!host || !HD_COLORS.length) return;
    host.innerHTML = '';
    var cols = HD_SPRITE.cols, rows = HD_SPRITE.rows;
    HD_COLORS.forEach(function (c) {
      var col = c.c.charCodeAt(0) - 65;
      var row = parseInt(c.c.slice(1), 10) - 1;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'blm-entry__sw' + (S.color && S.color.c === c.c ? ' is-on' : '');
      b.title = (c.n || c.c) + ' (' + c.c + ')';
      b.setAttribute('aria-label', 'Mat color ' + (c.n || c.c));
      b.dataset.cell = c.c;
      b.style.backgroundColor = c.h; // instant fallback before the sprite paints
      if (SPRITE_URL) {
        b.style.backgroundImage = 'url(' + SPRITE_URL + ')';
        b.style.backgroundSize = (cols * 100) + '% ' + (rows * 100) + '%';
        b.style.backgroundPosition = (col / (cols - 1) * 100) + '% ' + (row / (rows - 1) * 100) + '%';
      }
      b.addEventListener('click', function () { setColor(c); });
      host.appendChild(b);
    });
  }
  function setColor(c) {
    if (!c) return;
    S.color = c;
    var host = el('blmColorGrid');
    if (host) [].forEach.call(host.children, function (b) { b.classList.toggle('is-on', b.dataset.cell === c.c); });
    var nm = el('blmColorName'); if (nm) nm.textContent = (c.n || c.c) + ' · ' + c.c;
    var chip = el('blmColorChip'); if (chip) { chip.style.backgroundColor = c.h; if (SPRITE_URL) { var col = c.c.charCodeAt(0) - 65, row = parseInt(c.c.slice(1), 10) - 1; chip.style.backgroundImage = 'url(' + SPRITE_URL + ')'; chip.style.backgroundSize = (HD_SPRITE.cols * 100) + '% ' + (HD_SPRITE.rows * 100) + '%'; chip.style.backgroundPosition = (col / (HD_SPRITE.cols - 1) * 100) + '% ' + (row / (HD_SPRITE.rows - 1) * 100) + '%'; } }
    render();
  }

  // ── Canvas preview ─────────────────────────────────────────────────────────
  // Reflects size + color + orientation + logo (scale/x/y) together, live.
  var renderTok = 0;
  function render() {
    if (!ctx || !cv) return;
    var tok = ++renderTok;
    var d = dims(S.size ? S.size.label : "3' x 2'");
    var aspect = d.hFt / d.wFt;                   // >1 = tall (runner)
    var CW = 760;
    // TRUE aspect always (2026-10-27): the old 2.2 cap distorted tall runners.
    // Very tall mats instead render narrower inside a height-capped canvas.
    var CH = Math.max(220, Math.min(1140, Math.round(CW * aspect)));
    if (cv.width !== CW) cv.width = CW;
    if (cv.height !== CH) cv.height = CH;
    // mat rect: fit within the canvas preserving the oriented aspect, centered
    var pad = 26, availW = CW - pad * 2, availH = CH - pad * 2;
    var mw = availW, mh = mw * aspect;
    if (mh > availH) { mh = availH; mw = mh / aspect; }
    var geom = { mx: (CW - mw) / 2, my: (CH - mh) / 2, mw: mw, mh: mh, wFt: d.wFt, hFt: d.hFt };
    // ground
    ctx.clearRect(0, 0, CW, CH);
    ctx.fillStyle = '#f0f4f8'; ctx.fillRect(0, 0, CW, CH);
    // instant paint, then (color products only) overpaint with the true carpet tile
    paintMat(null, geom);
    if (COLOR_ENABLED && S.color) {
      tileImg(S.color.c, function (tile) { if (tok !== renderTok || !tile) return; paintMat(tile, geom); });
    }
    var cap = el('blmPreviewCap');
    if (cap) cap.textContent = (S.size ? S.size.label : '') + (S.color ? ' · ' + (S.color.n || S.color.c) : '')
      + ' · ' + (S.orientation === 'portrait' ? 'Portrait/Runner' : 'Landscape') + (S.logoName ? ' · ' + S.logoName : '')
      + ' — shown to scale with the standard 1-inch black rubber edge (confirmed manufacturer specification); the finished size includes the edge. Screen colors are an approximation of the production color chart.';
    var ol = el('blmOrientLabel'); if (ol) ol.textContent = orientationLabel();
  }

  function paintMat(tile, g) {
    /* Physical geometry (2026-10-27) — anchored to the actual manufactured
       product (LogoMats/M+A HD-printed logo mats, e.g. Berber Impressions HD
       for the HD Printed Entryway Mat): flat printed carpet face FULL BLEED to
       a black rubber edge EXACTLY 1" wide on all four sides (CONFIRMED manufacturer spec 2026-10-27; constant physical width),
       corners effectively square, no stitched binding band, no gloss sheen —
       the old preview drew a proportional frame + fake binding; both removed.
       Per-product overrides: window.BLM_CONFIG.borderIn / cornerIn (inches)
       for any product whose verified construction differs. */
    var mx = g.mx, my = g.my, mw = g.mw, mh = g.mh;
    var ppi = mw / ((g.wFt || 3) * 12);                 // canvas px per real inch
    var frame = Math.max(2, Math.round(ppi * (CONFIG.borderIn != null ? CONFIG.borderIn : 1)));
    var rad = Math.max(2, Math.round(ppi * (CONFIG.cornerIn != null ? CONFIG.cornerIn : 0.5)));
    var safe = Math.max(2, Math.round(ppi * 1));        // artwork safety margin, ~1"
    // Color products: the selected swatch hex (then the carpet tile overpaints).
    // Printed products (no color step): a light neutral printed-mat surface.
    var fallback = COLOR_ENABLED ? (S.color ? S.color.h : '#3a4049') : '#e9ecf1';
    // black rubber edge — part of the finished size, drawn INSIDE the mat rect
    ctx.save(); ctx.shadowColor = 'rgba(13,36,97,.20)'; ctx.shadowBlur = 20; ctx.shadowOffsetY = 8;
    ctx.fillStyle = COLOR_ENABLED ? '#0a0b0d' : '#2b3038'; ctx.beginPath(); roundRect(ctx, mx, my, mw, mh, rad); ctx.fill();
    ctx.restore();
    // printed face: finished size minus the rubber edge — full-bleed print
    var fxX = mx + frame, fxY = my + frame, fxW = mw - frame * 2, fxH = mh - frame * 2;
    var fxR = Math.max(1, rad - Math.round(frame * 0.4));
    ctx.save();
    ctx.beginPath(); roundRect(ctx, fxX, fxY, fxW, fxH, fxR); ctx.clip();
    if (tile) { try { ctx.fillStyle = ctx.createPattern(tile, 'repeat'); } catch (e) { ctx.fillStyle = fallback; } }
    else ctx.fillStyle = fallback;
    ctx.fillRect(fxX, fxY, fxW, fxH);
    ctx.restore();
    // usable inner area (logo lives here) — printed face minus the safety margin
    var inX = fxX + safe, inY = fxY + safe, inW = fxW - safe * 2, inH = fxH - safe * 2;
    if (S.logoImg && S.logoImg.complete && S.logoImg.naturalWidth) {
      var ratio = S.logoImg.naturalHeight / S.logoImg.naturalWidth;
      var lw = inW * S.art.scale, lh = lw * ratio;
      if (lh > inH * 0.96) { lh = inH * 0.96; lw = lh / ratio; }
      var cx = inX + inW / 2 + S.art.dx * inW, cy = inY + inH / 2 + S.art.dy * inH;
      // clamp inside the usable area, then write the clamped position back
      cx = Math.max(inX + lw / 2, Math.min(inX + inW - lw / 2, cx));
      cy = Math.max(inY + lh / 2, Math.min(inY + inH - lh / 2, cy));
      S.art.dx = inW ? (cx - inX - inW / 2) / inW : 0;
      S.art.dy = inH ? (cy - inY - inH / 2) / inH : 0;
      ctx.save(); ctx.beginPath(); roundRect(ctx, inX, inY, inW, inH, 4); ctx.clip();
      ctx.shadowColor = 'rgba(0,0,0,.20)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
      try { ctx.drawImage(S.logoImg, cx - lw / 2, cy - lh / 2, lw, lh); } catch (e) {}
      ctx.restore();
    } else if (S.file) {
      ctx.fillStyle = 'rgba(255,255,255,.95)'; ctx.textAlign = 'center';
      ctx.font = '700 18px "Plus Jakarta Sans",Arial,sans-serif';
      ctx.fillText('Artwork received', mx + mw / 2, my + mh / 2 - 6);
      ctx.font = '500 13px "Plus Jakarta Sans",Arial,sans-serif'; ctx.fillStyle = 'rgba(255,255,255,.8)';
      ctx.fillText(S.logoName, mx + mw / 2, my + mh / 2 + 16);
    } else {
      ctx.fillStyle = 'rgba(255,255,255,.72)'; ctx.textAlign = 'center';
      ctx.font = '600 15px "Plus Jakarta Sans",Arial,sans-serif';
      ctx.fillText('Upload your logo to see it here', mx + mw / 2, my + mh / 2);
    }
  }
  function setOrientation(o) {
    S.orientation = o;
    var pills = document.querySelectorAll('[data-blm-orient]');
    for (var i = 0; i < pills.length; i++) pills[i].classList.toggle('is-selected', pills[i].getAttribute('data-blm-orient') === o);
    var lbl = el('blmOrientLabel'); if (lbl) lbl.textContent = orientationLabel();
    render();
  }

  // ── Upload handling ──────────────────────────────────────────────────────
  function acceptFile(file) {
    if (!file) return;
    S.file = file; S.logoName = file.name; S.logoImg = null;
    var fn = qs('[data-blm-filename]', form);
    if (fn) { fn.textContent = '✓ ' + file.name; fn.hidden = false; }
    var box = qs('.blm-entry__upload', form);
    if (box) { box.classList.add('has-file'); box.classList.remove('is-error'); }
    var errEl = qs('[data-blm-upload-err]', form); if (errEl) errEl.hidden = true;
    if (IMG_RE.test(file.name) && file.type !== 'application/pdf') {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { S.logoImg = img; S.art = { scale: 0.5, dx: 0, dy: 0 }; render(); };
      img.onerror = function () { S.logoImg = null; render(); };
      img.src = url;
    } else {
      render();
    }
    var ctrls = el('blmArtCtrls'); if (ctrls) ctrls.hidden = !IMG_RE.test(file.name);
  }

  // ── Preview capture + upload to BMOS ─────────────────────────────────────
  function capturePreview() {
    try { return cv && cv.width ? cv.toDataURL('image/png') : null; } catch (e) { return null; }
  }
  function uploadPreview(cb) {
    var png = capturePreview();
    if (!png || !window.fetch) { cb(null, null); return; }
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    fetch(DP_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        png: png, station: STATION,
        config: { size: S.size ? S.size.label : '', file: S.logoName,
          color: S.color ? (S.color.n || S.color.c) + ' · chart ' + S.color.c : '',
          orientation: orientationLabel(),
          placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) } }
      }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { return r.json(); })
      .then(function (j) { clearTimeout(t); if (j && j.ok) cb(j.id, j.url); else cb(null, null); })
      .catch(function () { clearTimeout(t); cb(null, null); });
  }

  function hidden(name, value) {
    var i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = value; form.appendChild(i);
  }

  // ── Add to cart (native form submit + preview/proof wiring) ──────────────
  var submitting = false;
  form.addEventListener('submit', function (e) {
    if (submitting) return; // our own re-submit
    e.preventDefault();
    if (S.size && S.size.custom) { openCsq(); return; } // never cart a $0 custom size
    var errEl = qs('[data-blm-upload-err]', form);
    var box = qs('.blm-entry__upload', form);
    if (!fileInput || !fileInput.files || !fileInput.files.length) {
      if (errEl) errEl.hidden = false;
      if (box) { box.classList.add('is-error'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var btn = qs('.blm-entry__submit', form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding to cart…'; }
    uploadPreview(function (previewId, previewUrl) {
      hidden('properties[_design_id]', designId());
      hidden('properties[_design_station]', STATION);
      if (S.color) { hidden('properties[Mat Color]', (S.color.n || S.color.c) + ' · chart ' + S.color.c); hidden('properties[_hd_chart_cell]', S.color.c); }
      hidden('properties[Orientation]', orientationLabel());
      hidden('properties[_mat_size_ft]', S.size ? S.size.label : '');
      hidden('properties[_artwork_placement]', JSON.stringify({ orientation: S.orientation, scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4), file: S.logoName }));
      hidden('properties[_designed_at]', new Date().toISOString());
      if (previewId) hidden('properties[_preview_id]', previewId);
      if (previewUrl) hidden('properties[_preview_url]', previewUrl);
      hidden('properties[_proof_status]', 'AWAITING PROOF APPROVAL');
      submitting = true;
      form.submit(); // native multipart POST → /cart/add (file attaches) → /cart
    });
  });

  // ── Custom Size quote modal ──────────────────────────────────────────────
  function openCsq() {
    var m = el('blmCsq'); if (!m) return;
    el('blmCsqForm').hidden = false; el('blmCsqDone').hidden = true;
    var err = el('blmCsqErr'); if (err) err.hidden = true;
    m.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closeCsq() { var m = el('blmCsq'); if (m) m.hidden = true; document.body.style.overflow = ''; }
  function csqFile() { var i = el('blmCsqFile'); return i && i.files && i.files[0] ? i.files[0] : null; }
  // Upload the client's artwork first (if any); a failed upload never blocks the quote.
  function uploadQuoteArtwork(file, cb) {
    if (!file || !window.FileReader) { cb(null); return; }
    var fr = new FileReader();
    fr.onload = function () {
      fetch(ARTWORK_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, data: String(fr.result) }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { cb(j && j.ok ? { url: j.url, name: j.name } : null); })
        .catch(function () { cb(null); });
    };
    fr.onerror = function () { cb(null); };
    fr.readAsDataURL(file);
  }
  function sendCsq() {
    var err = el('blmCsqErr');
    function fail(t) { if (err) { err.hidden = false; err.textContent = t; } var btn = el('blmCsqSend'); if (btn) { btn.disabled = false; btn.textContent = SUBMIT_LABEL; } }
    var name = el('blmCsqName').value.trim(), email = el('blmCsqEmail').value.trim(), phone = el('blmCsqPhone').value.trim();
    var width = el('blmCsqWidth').value.trim(), length = el('blmCsqLength').value.trim();
    var qty = (el('blmCsqQty').value || '').trim() || '1';
    if (!name) return fail('Please enter your full name.');
    if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) return fail('Please enter a valid email address.');
    if (!phone) return fail('Please enter your phone number.');
    if (!width || !length) return fail('Please enter the mat width and length.');
    if (err) err.hidden = true;
    var btn = el('blmCsqSend'); if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    uploadQuoteArtwork(csqFile(), function (art) {
      var payload = {
        brand: 'blm', name: name, company: el('blmCsqCompany').value.trim(),
        email: email, phone: phone, width: width, length: length, quantity: qty,
        useLocation: el('blmCsqUse') ? el('blmCsqUse').value : '',
        notes: el('blmCsqNotes').value.trim(),
        website: el('blmCsqHP') ? el('blmCsqHP').value : '',
        artworkUrl: art ? art.url : '', artworkName: art ? art.name : '',
        pageUrl: window.location.href.split('?')[0]
      };
      fetch(CSQ_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (j) {
          if (btn) { btn.disabled = false; btn.textContent = SUBMIT_LABEL; }
          if (j && j.ok) { el('blmCsqForm').hidden = true; el('blmCsqDone').hidden = false; }
          else fail((j && j.error) || 'Something went wrong — please try again.');
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = SUBMIT_LABEL; } fail('Could not reach our server — please try again.'); });
    });
  }

  // ── Wire everything ────────────────────────────────────────────────────────
  var pills = form.querySelectorAll('.blm-entry__size-pill');
  for (var i = 0; i < pills.length; i++) {
    (function (pill) {
      pill.addEventListener('click', function () { selectSize(sizeFor(pill.getAttribute('data-variant-id')), pill); });
    })(pills[i]);
  }
  if (fileInput) fileInput.addEventListener('change', function () { acceptFile(fileInput.files && fileInput.files[0]); });
  // drag/drop onto the upload box
  var box = qs('.blm-entry__upload', form);
  if (box) {
    ['dragenter', 'dragover'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('is-drag'); }); });
    box.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f && fileInput && window.DataTransfer) { try { var dt = new DataTransfer(); dt.items.add(f); fileInput.files = dt.files; } catch (x) {} acceptFile(f); }
    });
  }
  // position controls
  function bind(id, fn) { var b = el(id); if (b) b.addEventListener('click', fn); }
  bind('blmArtBigger', function () { S.art.scale = Math.min(1.1, S.art.scale * 1.12); render(); });
  bind('blmArtSmaller', function () { S.art.scale = Math.max(0.12, S.art.scale * 0.89); render(); });
  bind('blmArtLeft', function () { S.art.dx -= 0.04; render(); });
  bind('blmArtRight', function () { S.art.dx += 0.04; render(); });
  bind('blmArtUp', function () { S.art.dy -= 0.04; render(); });
  bind('blmArtDown', function () { S.art.dy += 0.04; render(); });
  bind('blmArtReset', function () { S.art = { scale: 0.5, dx: 0, dy: 0 }; render(); });
  // vertical quick-positions (esp. for runners): toward top / center / bottom
  bind('blmArtTop', function () { S.art.dy = -0.42; render(); });
  bind('blmArtCenter', function () { S.art.dy = 0; render(); });
  bind('blmArtBottom', function () { S.art.dy = 0.42; render(); });
  // orientation control (landscape / portrait-runner)
  var oBtns = document.querySelectorAll('[data-blm-orient]');
  for (var oi = 0; oi < oBtns.length; oi++) (function (btn) {
    btn.addEventListener('click', function () { setOrientation(btn.getAttribute('data-blm-orient')); });
  })(oBtns[oi]);
  // custom-size modal controls (shared with the quote-only path)
  wireCsq();

  // build the 150-color grid + select a default — color products only
  if (COLOR_ENABLED) {
    buildColors();
    setColor(colorByCell(DEFAULT_CELL) || HD_COLORS[0] || null);
  }
  setOrientation('landscape'); // default; also sets the orientation label

  // initial state: select the first non-custom size
  var first = null; for (var k = 0; k < CFG.sizes.length; k++) if (!CFG.sizes[k].custom) { first = CFG.sizes[k]; break; }
  var firstPill = first ? qs('.blm-entry__size-pill[data-variant-id="' + first.id + '"]', form) : null;
  if (first) selectSize(first, firstPill); else render();
})();
